module.exports = require("vtk.js/Sources/Widgets/Widgets3D/PaintWidget");